import React, { useState } from 'react';
import { collection, query, orderBy, limit } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { db, auth } from '../config/firebase';
import { NowPlaying } from './NowPlaying';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { PinnedMessage } from './PinnedMessage';
import { useSpotifyPlayer } from '../hooks/useSpotifyPlayer';
import { useAdminStatus } from '../hooks/useAdminStatus';
import { usePinnedMessage } from '../hooks/usePinnedMessage';
import { useSpotifyStatus } from '../hooks/useSpotifyStatus';


export default function Chat({ spotifyProfile }) {
    const { currentlyPlaying, isPlaying, isPlayingFromZero } = useSpotifyPlayer();
    const { isAdmin } = useAdminStatus();
    const { pinnedMessage, pinMessage, unpinMessage } = usePinnedMessage(spotifyProfile);
    const { isPremium, isLoading } = useSpotifyStatus();
    const [replyingTo, setReplyingTo] = useState(null);
    
    const messagesRef = collection(db, 'messages');
    const messagesQuery = query(messagesRef, orderBy('createdAt', 'asc'), limit(50));
    const [snapshot] = useCollection(messagesQuery);
    
    const messages = snapshot?.docs.map(doc => ({
      id: doc.id, 
      ...doc.data()
    })) || [];


    const handlePinMessage = async (message, duration) => {
      try {
        await pinMessage(message, duration);
      } catch (error) {
        console.error('Error pinning message:', error);
      }
    };

    const handleReplyMessage = (message) => {
      // console.log('Setting reply to:', message);
      setReplyingTo(message);
    };
  
    return (
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <h2 className="text-xl font-bold text-white">
                Linkin Park Chat Room
              </h2>
              {isAdmin && (
                <span className="px-2 py-1 bg-blue-400/30 text-white text-xs font-medium rounded-full">
                  Admin
                </span>
              )}
            </div>
          </div>
    
          <div className="px-6 py-4 space-y-6">
            <div className="bg-gray-50 rounded-lg p-4">
              <NowPlaying
                currentlyPlaying={currentlyPlaying}
                isPlaying={isPlaying}
              />
            </div>
    
            {pinnedMessage && (
              <div className="border-l-4 border-blue-500 bg-blue-50 p-4 rounded-r-lg">
                <PinnedMessage
                  pinnedMessage={pinnedMessage}
                  isAdmin={isAdmin}
                  onUnpin={unpinMessage}
                />
              </div>
            )}
    
            <div className="bg-gray-50 rounded-xl">
              <MessageList
                messages={messages}
                isAdmin={isAdmin}
                onPinMessage={handlePinMessage}
                onReplyMessage={handleReplyMessage}
                currentUserId={auth.currentUser?.uid}
              />
            </div>
    
            <div className="pt-4">
              <MessageInput
                spotifyProfile={spotifyProfile}
                currentlyPlaying={currentlyPlaying}
                isPlayingFromZero={isPlayingFromZero}
                isPremium={isPremium}
                isLoading={isLoading}
                replyingTo={replyingTo}
                onCancelReply={() => setReplyingTo(null)}
              />
            </div>
          </div>
        </div>
    );
}